import { CSSProperties, FC } from 'react';

import config from '@rikstv/play-common/src/config';

import { StandardItem, StandardItemProps } from './StandardItem';

import styles from './NumberedItem.module.css';

type NumberedItemProps = StandardItemProps & { index: number };

export const NumberedItem: FC<NumberedItemProps> = props => {
  //Different line-height is needed for the different brands
  const lineHeight = config.application === 'Strim' ? '0.65' : '0.75';
  const style: CSSProperties & { [key: string]: string | number } =
    props.swimlaneStyle === 'NumberedPortrait'
      ? { '--font-size': 'clamp(150px, 12vw, 213px)', lineHeight }
      : { '--font-size': 'clamp(125px, 10vw, 200px)', lineHeight };

  return (
    <div className={styles.container}>
      <p style={style} className={styles.number}>
        {props.index}
      </p>

      <StandardItem {...props} hideCaption />
    </div>
  );
};
